module.exports = __webpack_public_path__ + "img/service-a.fae65d9b.svg";